import { Check } from "../../../assets/icons";

import styles from "./CustomCheckbox.module.scss";

interface Props {
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string, checked: boolean) => void;
}

const CustomCheckbox = ({ label, value, checked, onChange }: Props) => {
  return (
    <label className={styles.label}>
      <input
        type="checkbox"
        value={value}
        checked={checked}
        onChange={(e) => onChange(value, e.target.checked)}
        className={styles.input}
      />
      <span className={styles.radio} />
      <span className={styles.text}>{label}</span>
      <span className={styles.checkmark}>{checked && <Check />}</span>
    </label>
  );
};

export default CustomCheckbox;